import { ApprovalTypeId } from "@maslul/common-services";

export abstract class ApprovalTypeData {

    public static approvalTypeToExcludeCountriesGroup: any[] = [
        ApprovalTypeId.TRANSPORT_COMMERCIAL_USED,
        ApprovalTypeId.TRANSPORT_PRODUCTS_COMMERCIAL,
        ApprovalTypeId.TRANSPORT_IMPORT_TO_EXPORT,
        ApprovalTypeId.QUOTA_LICENSE_3,
        ApprovalTypeId.QUOTA_LICENSE_4,
        ApprovalTypeId.QUOTA_LICENSE_5,
        ApprovalTypeId.QUOTA_LICENSE_6,
        ApprovalTypeId.TRAINS23,
        ApprovalTypeId.TRAINS0211,
        ApprovalTypeId.TRANSPORT_VESSEL,
        ApprovalTypeId.TRANSPORT_COMMERCIAL_USED,
        ApprovalTypeId.FOOD_REQUEST
    ];
    public static communicationApprovals = [
        ApprovalTypeId.COMMUNICATION_TYPE_DISPOSABLE,
        ApprovalTypeId.COMMUNICATION_TYPE_PERIODIC,
        ApprovalTypeId.COMMUNICATION_ADJUSTMENT_DISPOSABLE_COMMERCIAL,
        ApprovalTypeId.COMMUNICATION_ADJUSTMENT_DISPOSABLE_PRIVATE,
        ApprovalTypeId.COMMUNICATION_ADJUSTMENT_PERIODIC,
        //ApprovalTypeId.COMMUNICATION_ADJUSTMENT_PERIODIC_DECLARATION
    ];


    public static approvalOfManufacturerNameList = [
        ApprovalTypeData.communicationApprovals,
    ];
}